import { render, staticRenderFns } from "./getToKnowTheClub.vue?vue&type=template&id=24a974b6&scoped=true&"
import script from "./getToKnowTheClub.vue?vue&type=script&lang=js&"
export * from "./getToKnowTheClub.vue?vue&type=script&lang=js&"
import style0 from "./getToKnowTheClub.vue?vue&type=style&index=0&id=24a974b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a974b6",
  null
  
)

export default component.exports